/*
 * First-letter case for a label that is dropped into a sentence.
 * Plain functions with the locale passed in, so they are safe in getStaticProps.
 */

export const upperFirst = (text, locale) =>
  text ? text.charAt(0).toLocaleUpperCase(locale) + text.slice(1) : text;

/**
 * "Videojuegos" to "videojuegos". A label that opens with an acronym or a
 * mixed-case name keeps its case: "TV digitale", "PIN", "eSIM".
 */
export const lowerFirst = (text, locale) => {
  if (!text) return text;

  const [firstWord = ''] = text.match(/^\p{L}+/u) || [];
  if (/\p{Lu}/u.test(firstWord.slice(1))) return text;

  return text.charAt(0).toLocaleLowerCase(locale) + text.slice(1);
};

/** 'de' for 'de', 'de-AT'. */
export const languageOf = (locale) => String(locale || '').split('-')[0];
